export default {"src":"/_next/static/media/arrow-right-submit.2a9cb0aa.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};